import axiosInstance from "./axiosInstance";
import APIEndpoint from "./endpoint";

export const getDashboardList = async () => {
  const url = `${APIEndpoint.GET_DROPDOWN_DASHBOARD}`;

  const res = await axiosInstance.get(url);
  return res;
};

export const getDashboardDetail = (id) => {
  const uid = id;
  const api = APIEndpoint.GET_DASHBOARD_DETAIL + "/";
  const res = axiosInstance.get(api + uid);
  return res;
};

export const getDashboardCustomerSegment =()=>{
  const api = APIEndpoint.GET_DASHBOARD_CUSTOMER_SEGMENT ;
  console.log("api="+api);
  const res = axiosInstance.get(api);
  return res;
}
export const getDashboardMarketingActionPlan =(year)=>{
  const api = APIEndpoint.GET_DASHBOARD_MARKETING_ACTION_PLAN ;
  console.log("api="+api);
  const res = axiosInstance.get(api+"/"+year);
  return res;
}

export const getDashboardCrmPlan =(year)=>{
  const api = APIEndpoint.GET_DASHBOARD_CRM_PLAN ;
  console.log("api="+api);
  const res = axiosInstance.get(api+"/"+year);
  return res;
}

export const getDashboardFutureCustomerSegment = () =>
  axiosInstance.get(APIEndpoint.GET_DASHBOARD_FUTURE_CUSTOMER_SEGMENT);
